// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XJcc","search":"Settings_search__2MqzX","filter":"Settings_filter__2JBSw"};